import { Component } from '@angular/core';
import { BaseModalComponent } from '../../../core/modals/components/base-modal/base-modal.component';

@Component({
  selector: 'app-consent-agreement-modal',
  templateUrl: './consent-agreement-modal.component.html',
  styleUrls: ['./consent-agreement-modal.component.scss'],
})
export class ConsentAgreementModalComponent extends BaseModalComponent<{}> {}
